






























































































































































































import Vue from 'vue';
import _ from 'lodash';

import { required } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';
import GetSupplier from '@/graphql/GetSupplier.gql';

import {
  Component,
  Prop,
  Mixins,
  Watch,
} from 'vue-property-decorator';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';

import { CrudOperation } from '@/types/CrudOperation';
import { RateTableModel, WorkTypeModel, defaultWorkType } from '@/components/RatesPage/types';

import RatesSheet from '@/components/RatesPage/RatesSheet.vue';
import CustomSelect from '@/components/FormBuilder/CustomSelect.vue';

import objectHash from 'object-hash';
import { State } from 'vuex-class';
import { PlatformType, CostAccountType, CostCentersType } from '@/store/directory/types';

@Component({
  components: {
    RatesSheet,
    CustomSelect,
  },
})
export default class WorkTypeItem extends Mixins(EntityHelperMixin, validationMixin) {
  @Prop({
    type: Object,
    default: false,
  }) readonly workType!: WorkTypeModel

  @Prop({
    type: Array,
    default: false,
  }) readonly allWorkTypes!: Array<WorkTypeModel>

  @Validations()
  validations = {
    workTypeLocal: {
      name: {
        required,
      },
      platform: {
        required,
      },
      client: {
        required,
      },
      sheets: {
        required,
      },
      work_billing_type: {
        required,
      },
      cost_center: {
        required,
      },
      CostAccount: {
        required,
      },
      units: {
        required,
      },
    },
  }

  deleteDialog = false;

  CrudOperation = CrudOperation;

  panel: any = null;

  workTypeLocal: WorkTypeModel = _.cloneDeep(defaultWorkType);

  @State('platforms', { namespace: 'directory' })
  readonly platforms!: PlatformType[];

  clients: Array<Record<any, any>> = [];

  suppliers: Array<Record<any, any>> = [];

  suppliersNotSelected: Array<Record<any, any>> = [];

  workBillingTypes: Array<Record<any, any>> = [];

  units: Array<Record<any, any>> = [];

  @State('costCenters', { namespace: 'directory' })
  readonly costCenters!: CostCentersType[];

  @State('costAccounts', { namespace: 'directory' })
  readonly costAccounts!: CostAccountType[];

  async beforeMount() {
    this.workTypeChanged();
    this.clients = await this.loadClients();
    this.clients.map((client: any) => {
      if (client.showing_name === undefined && client.legal_name !== undefined) {
        client.showing_name = `${client.legal_name} (SAP_ID: ${client.sap_id})`;
      }
      return client;
    });
    this.workBillingTypes = await this.loadWorkBillingTypes();
    this.suppliers = await this.loadSuppliers();
    this.suppliersNotSelected = this.suppliers;
    this.units = await this.loadUnits();
  }

  get isWorkTypeChanged() {
    const workTypeHash = objectHash.sha1(this.workItemToComparable(this.workType));
    const workTypeLocalHash = objectHash.sha1(this.workItemToComparable(this.workTypeLocal));
    return workTypeHash !== workTypeLocalHash;
  }

  workItemToComparable(workType: WorkTypeModel): any {
    return {
      platformId: workType?.platform?.id,
      clientId: workType?.client?.id,
      cost_centerId: workType?.cost_center?.id,
      CostAccountId: workType?.CostAccount?.id,
      work_billing_typeId: workType?.work_billing_type?.id,
      sheets: workType?.sheets,
    };
  }

  sortRateTable(rateTable: Array<RateTableModel>): Array<RateTableModel> {
    return rateTable.sort((p: RateTableModel, n: RateTableModel) => {
      if (!p || !n) {
        return 0;
      }
      const {
        n_q,
        p_q,
        n_p,
        p_p,
      } = {
        n_q: n?.quality?.from || 0,
        p_q: p?.quality?.from || 0,
        n_p: n?.performance?.from || 0,
        p_p: p?.performance?.from || 0,
      };
      if (p_q !== n_q) {
        return p_q > n_q ? -1 : 1;
      }
      if (p_p !== n_p) {
        return p_p > n_p ? -1 : 1;
      }
      if (p.rate !== n.rate) {
        return p.rate > n.rate ? -1 : 1;
      }
      return 0;
    });
  }

  get supplierList() {
    return this.suppliers.filter((i: any) => i?.PlantsHR?.some((p: any) => Number(p.id) === Number(this.workType?.platform?.id)));
  }

  get creatingWorkType() {
    return !this.workType?.id;
  }

  getValidationErrors(validations: any): Array<string> {
    const errors: Array<string> = [];
    if (!validations || validations.$error === false || validations.$invalid === false) {
      return errors;
    }
    if (validations.required === false) {
      errors.push('Обязательное поле');
    }
    return errors;
  }

  @Watch('workType')
  workTypeChanged() {
    Vue.set(this, 'workTypeLocal', _.cloneDeep(this.workType));
  }

  loadClients() {
    return this.loadEntityListing('Client', {});
  }

  async loadSuppliers() {
    await this.$apollo.query({
      query: GetSupplier,
    }).then((res) => {
      const filteredEdges = res.data.getSupplierListing.edges.filter((edge: any) => {
        const plantsHR = edge.node.PlantsHR || [];
        return plantsHR.some((plant: any) => plant.id === this.workType?.platform?.id);
      });
      const final = filteredEdges.map((plant: any) => (plant?.node));
      this.suppliers = final;
    }).catch((e) => {
      console.error(e);
    });
    return this.suppliers;
  }

  loadWorkBillingTypes() {
    return this.loadEntityListing('WorkBillingType', {});
  }

  loadUnits() {
    return this.loadEntityListing('Units', {});
  }

  refreshSuppliers(value: any) {
    if (!this.workTypeLocal.sheets?.length) {
      return;
    }

    const idx = this.workTypeLocal.sheets.findIndex((sheet) => sheet.key === value.key);
    if (!this.workTypeLocal.sheets[idx]) {
      return;
    }

    Vue.set(this.workTypeLocal.sheets[idx], 'suppliers', value.suppliers);
  }

  changeRateTable(value: { cells: Array<RateTableModel>; suppliers: any; key: string }) {
    if (!this.workTypeLocal.sheets?.length) {
      return;
    }

    const idx = this.workTypeLocal.sheets.findIndex((sheet) => sheet.key === value.key);
    if (!this.workTypeLocal.sheets[idx]) {
      return;
    }

    Vue.set(this.workTypeLocal.sheets[idx], 'cells', value.cells);
    Vue.set(this.workTypeLocal.sheets[idx], 'suppliers', value.suppliers);
  }

  createRateTable(value: { cells: Array<RateTableModel>; suppliers: any; key: string }) {
    // eslint-disable-next-line no-unused-expressions
    this.workTypeLocal.sheets?.push(value);
  }

  updateComment(value: { sheetKey: string; comment: string }) {
    if (!this.workTypeLocal.sheets?.length) {
      return;
    }

    const idx = this.workTypeLocal.sheets.findIndex((sheet) => sheet.key === value.sheetKey);
    if (!this.workTypeLocal.sheets[idx]) {
      return;
    }

    Vue.set(this.workTypeLocal.sheets[idx], 'comment', value.comment);
  }

  emitAction(action: CrudOperation) {
    if (action === CrudOperation.delete) {
      this.deleteDialog = false;
      this.$emit('action', action, this.workTypeLocal);
      return;
    }
    this.$v.$touch();
    if (this.$v.$invalid === true) {
      this.$bus.$emit('notification', 'Форма заполнения не прошла валидацию', 'warning');
      return;
    }
    if (this.workTypeLocal?.sheets?.some((rateTable) => rateTable.cells?.some((i) => !i.rate))) {
      this.$bus.$emit('notification', 'Тариф не может быть равен нулю', 'warning');
      return;
    }
    if (action === CrudOperation.create && (!this.workTypeLocal?.name || this.allWorkTypes.some((i) => i.name === this.workTypeLocal.name))) {
      this.$bus.$emit('notification', 'Тип работы с таким именем уже существует', 'warning');
      return;
    }
    this.$emit('action', action, this.workTypeLocal);
  }
}

